import { ref } from 'vue';

import { recentSearchesModel } from '@/entities/recent-searches';

export function useRecentSearchesList() {
  const visibleSearches = ref(
    recentSearchesModel.recentSearches.getRecentSearches(),
  );

  const removeSearch = (timestamp: number) => {
    recentSearchesModel.recentSearches.removeRecentSearch(timestamp);
    visibleSearches.value = visibleSearches.value.filter(
      s => s.timestamp !== timestamp,
    );
  };

  const clearAll = () => {
    recentSearchesModel.recentSearches.clearRecentSearches();
    visibleSearches.value = [];
  };

  return { visibleSearches, removeSearch, clearAll };
}
